import { storeMarkerIcons } from '@/constants/maps';

export const customMarkerTemplate = (context, availableCount, icon) => {
  const iconCount = availableCount === false
    ? ''
    : `<div class="map-store-icon-count" style="z-index: 2">${availableCount}</div>`;

  return context?.templateLayoutFactory.createClass(
    `
      <div class="map-store-icon" style="z-index: 2">
          ${iconCount}
          <div class="map-store-icon-ic">
              <div style="background-image: url(${storeMarkerIcons[icon]})"></div>
              <svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 36C10.533 36 0 23.8 0 14C0 6.268 6.268 0 14 0C21.732 0 28 6.268 28 14C28 23.8 17.467 36 14 36Z" fill="#1A82CB"/>
              </svg>
          </div>
      </div>
    `
  ) || null;
};

export const pickupMarkerOptions = ({ context, count = 0, icon = 'store' }) => {
  return {
    iconLayout: customMarkerTemplate(context, count, icon),
    iconShape: {
      type: 'Polygon',
      coordinates: [
        [
          [0, 17],
          [5, 9],
          [20, 0],
          [31, 0],
          [34, 6],
          [34, 17],
          [29, 21],
          [25, 31],
          [17, 42],
          [10, 42],
          [0, 27],
        ],
      ],
    },
  };
};

export const createBalloon = (api, { content = [] } = {}) => {
  if (!content.length) return {};

  const contentArray = [];
  content.forEach(({ label, text, isTitle }) => {
    contentArray.push(`
      <div class="custom-balloon__block">
        <div class="custom-balloon__label">${label}</div>
        <div class="${isTitle ? 'custom-balloon__title' : 'custom-balloon__text'}">${text}</div>
      </div>
    `);
  });

  const balloonLayout = api.templateLayoutFactory.createClass(
    `
      <div class="custom-balloon" style="transform: translate(-100%, -100%)">
        <svg class="custom-balloon__close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34227 21.6571C2.57016 21.8856 2.86991 21.9995 3.1685 21.9995C3.46768 21.9995 3.76685 21.8856 3.99474 21.6571L12 13.6525L20.0053 21.6571C20.2331 21.8856 20.5323 21.9995 20.8315 21.9995C21.1307 21.9995 21.4298 21.8856 21.6577 21.6571C22.1141 21.2014 22.1141 20.461 21.6577 20.0047L13.6525 12L21.6577 3.99473C22.1141 3.53837 22.1141 2.79863 21.6577 2.34227C21.202 1.88591 20.461 1.88591 20.0053 2.34227L12 10.3475L3.99474 2.34227C3.53897 1.88591 2.79804 1.88591 2.34227 2.34227C1.88591 2.79863 1.88591 3.53837 2.34227 3.99473L10.3475 12L2.34227 20.0047C1.88591 20.461 1.88591 21.2014 2.34227 21.6571Z" fill="#E0E0E0"/>
        </svg>
        <div class="custom-balloon__arrow"></div>
         ${contentArray.join('')}
      </div>
    `,
    {
      build() {
        this.constructor.superclass.build.call(this);

        this._$element = this.getParentElement().querySelector(`.custom-balloon`);
        this.onCloseClick = function (e) {
          e.preventDefault();
          this.events.fire('userclose');
        }.bind(this);

        this._$element.querySelector('.custom-balloon__close').addEventListener('click', this.onCloseClick);
      },

      clear() {
        this._$element.querySelector('.custom-balloon__close').removeEventListener('click', this.onCloseClick);
        this.constructor.superclass.clear.call(this);
      },

      onSublayoutSizeChange() {
        balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
        if (!this._isElement(this._$element)) return;
        this.events.fire('shapechange');
      },

      getShape() {
        if (!this._isElement(this._$element)) return balloonLayout.superclass.getShape.call(this);

        return new api.shape.Rectangle(new api.geometry.pixel.Rectangle([
          [-this._$element.offsetWidth, -this._$element.offsetHeight],
          [-this._$element.offsetWidth, -this._$element.offsetHeight],
        ]));
      },

      _isElement: (element) => !!element?.querySelector('.custom-balloon__arrow'),
    },
  );

  return {
    balloonShadow: false,
    balloonLayout,
    balloonPanelMaxMapArea: 0,
    hideIconOnBalloonOpen: false, // Не скрываем иконку при открытом балуне.
    balloonOffset: [20, -10], // смещаем балун, для открытия над иконкой
  };
};
